import * as React from 'react';
import { SVGProps } from 'react';

const SvgDenyCircle = (
  props: SVGProps<SVGSVGElement> & React.HTMLAttributes<HTMLElement>
) => (
  <svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 3c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9Zm7 9c0 1.57-.53 3.02-1.4 4.18L7.82 6.4C8.98 5.53 10.43 5 12 5c3.86 0 7 3.14 7 7ZM5 12c0-1.57.53-3.02 1.4-4.18l9.78 9.78c-1.16.87-2.61 1.4-4.18 1.4-3.86 0-7-3.14-7-7Z"
      fill="#7B61FF"
    />
  </svg>
);
export default SvgDenyCircle;
